import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import { createWeb3Modal, defaultConfig } from "@web3modal/ethers5/react";
import tokenAbi from "../../Connectivity/abi/tokenAbi.json";
import NFTAbi from "../../Connectivity/abi/NFTAbi.json";
import CircularProgress from "@mui/material/CircularProgress";
import {
  buyId,
  masterProcessingIdea,
  payForEvoluteIdea,
} from "../../../redux/admin/action";
import {
  useWeb3ModalProvider,
  useWeb3ModalAccount,
} from "@web3modal/ethers5/react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import WalletLoader from "../../../components/common/WalletLoader";
import PagesIndex from "../../PagesIndex";

const projectId = "2fa6c12dde1b5cd1a88e4fd4cb690bca";

const PolygonMainnet = {
  chainId: 137,
  name: "Polygon Mainnet",
  currency: "MATIC",
  explorerUrl: "https://polygonscan.com/",
  rpcUrl:
    "https://polygon-mainnet.infura.io/v3/8c79ca71179c4e318999034a96a93f31",
};

const metadata = {
  name: "Episapient.io",
  description: "Episapient.io",
  url: "https://episapient.appworkdemo.com/wallet/backtoapp",
  icons: ["https://avatars.mywebsite.com/"],
};

createWeb3Modal({
  ethersConfig: defaultConfig({ metadata }),
  chains: [PolygonMainnet],
  projectId,
  enableAnalytics: true,
});

export default function MasterProcessingFee() {
  const [processingLog, setProcessingLog] = useState();
  const [isVisible, setIsVisible] = useState(true);
  const { walletProvider } = useWeb3ModalProvider();
  const { id } = PagesIndex.useParams();
  const [pinataUrl, setPinataUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { address, chainId, isConnected } = useWeb3ModalAccount();

  let MasterPaymentFee = 500;
  async function handleApprove() {
    setLoading(true);
    const provider = new ethers.providers.Web3Provider(walletProvider);
    const signer = provider.getSigner();
    const tokenContract = new ethers.Contract(
      "0x3C1e77fb138a2448153008bBe69803285c38ce96",
      tokenAbi,
      signer
    );
    const nftcontract = new ethers.Contract(
      "0x01729d1848e02080532bed93bae7E5Dba513E557",
      NFTAbi,
      signer
    );

    try {
      setProcessingLog("approving the transaction...");
      let fees2 = ethers.utils.parseEther(MasterPaymentFee?.toString());
      const tx = await tokenContract.approve(
        "0x01729d1848e02080532bed93bae7E5Dba513E557",
        fees2.toString()
      );
      await tx.wait();
      let feesTransfer = await nftcontract.evolveIdea(pinataUrl);
      await feesTransfer.wait();
      setProcessingLog("Minting NFT...");
      const receipt = await provider.getTransactionReceipt(feesTransfer.hash);
      // console.log(feesTransfer, "feesTransfer");
      // console.log(receipt, "receiptttt");

      if (receipt.status === 1) {
        if (feesTransfer.hash) {
          let NFTID = await getTokenId(feesTransfer);
          setProcessingLog("Executing smart contract for payment fees...");
          let values = {
            id: id,
            tx_hash: feesTransfer.hash,
            nftSmartContractId: NFTID,
          };
          setProcessingLog("Executing api call...");
          setTimeout(() => {
            masterProcessingIdea(values).then((res) => {
              setProcessingLog("");
              if (res?.status === 201) {
                setLoading(false);
                navigate("/wallet/success");
              } else {
                setLoading(false);
                navigate("/wallet/success");
              }
            });
          }, 1000);
        } else {
          setLoading(false);
          alert("Transaction is not completed. please try again");
        }
      } else {
        setLoading(false);
        alert("Transaction failed");
      }
    } catch (error) {
      setLoading(false);
      alert(error?.message);
      console.log("error?.message", error?.message);
    }
  }

  // Loader User Effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  const getTokenId = async (feesTransfer) => {
    try {
      const provider = new ethers.providers.Web3Provider(walletProvider);
      const receipt = await provider.getTransactionReceipt(feesTransfer?.hash);
      if (receipt && receipt?.logs) {
        const tokenInterface = new ethers.utils.Interface([
          "event nftdetails(address indexed ownerAddress, uint256 indexed tokenId, string indexed tokenURI)",
        ]);
        const transferLog = receipt?.logs?.find((log) =>
          log?.topics?.includes(tokenInterface.getEventTopic("nftdetails"))
        );
        // console.log(await transferLog?.topics[2], "logData");
        let value = await transferLog?.topics[2];
        let tokenId = parseInt(value, 16);
        // console.log("token id get", tokenId);
        return tokenId;
      } else {
        console.log("No logs found in the transaction receipt.", "");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  useEffect(() => {
    let values = { id: id };
    buyId(values).then((res) => {
      setPinataUrl(res?.data?.pinataUrl);
    });
  }, []);

  // 10 Min timer
  const [timeLeft, setTimeLeft] = useState(600); // 600 seconds = 10 minutes
  useEffect(() => {
    if (loading) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
      return () => clearInterval(timer); // Clean up the interval on component unmount
    } else {
      setTimeLeft(600);
    }
  }, [loading]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <>
      <div className="wallet-box">
        <div className="wallet-box-cont">
          <div className="logo-box">
            <img src={PagesIndex.Png.newLogo} alt="" />
            <div className="logo-title">EPISAP</div>
          </div>
          <w3m-button />
          <div className="add-word-break">{address}</div>
          <h4 className="wallet-title">
            Idea Minting Fees <br />
            500 VHT
          </h4>
          <div className="wallet-btn-approve">
            <button
              onClick={handleApprove}
              disabled={!isConnected || loading}
              className={`loader-white ${!isConnected ? "disable-color" : ""}`}
            >
              {loading == true ? <CircularProgress size={16} /> : "Approve"}
            </button>
          </div>
          <div className="wallet-subtitle">{processingLog}</div>
          {loading && (
            <>
              <p>
                <strong>
                  The payment is still processing. Please don't close the app or turn off your screen. Wait until you get a response from the wallet. If you don't, you might lose your data.
                </strong>
              </p>
              <h3>Countdown Timer</h3>
              <div style={{ fontSize: "1.5rem" }}>{formatTime(timeLeft)}</div>
            </>
          )}

        </div>
      </div>
      {isVisible && (
        <div className="wallet-loader">
          <WalletLoader />
        </div>
      )}
    </>
  );
}
